<template>
  <div>
    <div class="page f-pr">
      <!-- Full Design Background -->
      <img src="../assets/harbour/hero.png" alt="" class="hero-bg" />

      <!-- Interactive Icons Overlay -->
      <div class="icon-btn icon-history" @click="goToHistoryMap">
        <img src="../assets/harbour/icon-history.png" alt="" />
      </div>
      <div class="icon-btn icon-bar" @click="goToBarMap">
        <img src="../assets/harbour/icon-bar.png" alt="" />
      </div>
      <div class="icon-btn icon-event" @click="goToEventInfo">
        <img src="../assets/harbour/icon-event.png" alt="" />
      </div>

      <!-- CTA Button Overlay -->
      <!-- <div class="cta-btn" @click="getGift">
        <img src="../assets/harbour/btn-gift.png" alt="" />
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'HarbourActivity',
  data() {
    return {}
  },
  methods: {
    goToHistoryMap() {
      this.$router.push('/history-map')
    },
    goToBarMap() {
      this.$router.push('/bar-map')
    },
    goToEventInfo() {
      this.$router.push('/schedule')
    },
    getGift() {
      // TODO: Implement gift redemption logic
    }
  }
}
</script>

<style scoped lang="less">
.page {
  position: absolute;
  width: 100%;
  min-height: 100vh;
  left: 0;
  top: 0;
  background: #0a1f1f;
  overflow-x: hidden;
}

.hero-bg {
  display: block;
  width: 750px;
  margin: 0 auto;
}

.icon-btn {
  position: absolute;
  top: 1200px;

  img {
    display: block;
    width: 100%;
  }

  &:active {
    opacity: 0.8;
  }
}

.icon-history {
  left: 30px;
  width: 197px;
}

.icon-bar {
  left: 275px;
  width: 200px;
}

.icon-event {
  left: 518px;
  width: 202px;
}

.cta-btn {
  position: absolute;
  top: 1428px;
  left: 111px;
  width: 528px;

  img {
    display: block;
    width: 100%;
  }

  &:active {
    opacity: 0.8;
  }
}
</style>
